import autoComplete from '@tarekraafat/autocomplete.js';
import { counties } from './counties';

const $ = document.querySelectorAll.bind(document);
const $1 = document.querySelector.bind(document);

let domain = window.location.hostname;

if (!['www.charlotteobserver.com', 'www.newsobserver.com'].includes(domain)) {
  domain = 'www.charlotteobserver.com';
}

function initAutoComplete(data) {
  new autoComplete({
    data: {
      src: counties,
      cache: true
    },
    placeHolder: 'Alamance',
    resultsList: {
      render: true,
      container: source => {
        source.setAttribute('id', 'countyList');
      },
      destination: document.querySelector('#autoComplete'),
      position: 'afterend',
      element: 'ul'
    },
    onSelection: function(d) {
      const videoPlayer = $1('.county-player > iframe');
      const selection = d.selection.value;
      data.allCounties.forEach(d => {
        if (d.county === selection) {
          videoPlayer.src = `https://${domain}/news/politics-government/election/article${d.CUE_ID}.html/video-embed`;
          videoPlayer.setAttribute('data-name', d.county);

          $('.county-card').forEach(el => {
            el.classList.remove('county-card--active');
            if (el.dataset.name == videoPlayer.dataset.name) {
              el.classList.add('county-card--active');
            }
          });
        } else {
          let foo = $1(`.county-card[data-name="${d.county.trim()}"]`);
          foo.classList.add('county-card--hidden');
        }
      });

      $1('.input__reset-btn').style.visibility = 'visible';
      $1('#autoComplete').value = '';
      $1('#autoComplete').setAttribute('placeholder', selection);
    }
  });
}

export default initAutoComplete;
